import { TrackerProgressTile, TrackerProgressTileProps } from "../TrackerProgressTile";

import { ReactComponent as SleepIcon } from "@icons/sleep.svg";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useTranslation } from "react-i18next";

interface SleepTrackerProgressTileProps {
  inCard?: boolean;
  size?: TrackerProgressTileProps["size"];
}

export const SleepTrackerProgressTile = ({ inCard, size = "lg" }: SleepTrackerProgressTileProps) => {
  const { t } = useTranslation();
  return (
    <TrackerProgressTile
      trackerType={TrackerType.Sleep}
      trackerPagePath="sleep"
      Icon={SleepIcon}
      caption={t("wellbeing.trackers.sleep.caption")}
      wrapInCard={inCard ?? true}
      size={size}
    />
  );
};
